<script lang="ts">
    import {getContext} from 'svelte';
    import type {LocalizeFunction} from '../../../../../svelte/types';
    import {LOCALIZE_KEY} from '../../../../../svelte/utils';

    import {pipe} from '../../../../../svelte/utils';
    import {characters, inline, loc, prop} from '../../../../../svelte/pipes';

    export let value: any; // TODO add type

    const localize: LocalizeFunction = getContext(LOCALIZE_KEY);
</script>

<template>
    <div>
        <div>
                <span class="nazevZaznamu"><a href="/#!/users/{value.id}"><span>{value.printableName}</span></a>
                    {#if value.username}
                    <code>{value.username}</code>
                {/if}
                </span>
            {#if value.readerRole?.blocked}
                <span class="label label-danger">{localize(/* @kp-localization ctenar.TransactionsBlocked */ 'ctenar.TransactionsBlocked')}</span>
            {/if}
            {#if value.readerRole?.registrationExpired}
                <span class="label label-danger">{localize(/* @kp-localization ctenar.RegistrationExpired */ 'ctenar.RegistrationExpired')}</span>
            {/if}
            {#if value.role?.includes('ROLE_READER')}
                <span class="label label-info reader-tag">{localize(/* @kp-localization user.Reader */ 'user.Reader')}</span>
            {/if}
            {#if value.role?.includes('ROLE_LIBRARIAN')}
                <span class="label label-info reader-tag">{localize(/* @kp-localization user.Librarian */ 'user.Librarian')}</span>
            {/if}
            {#if value.role?.includes('ROLE_LIBRARY')}
                <span class="label label-info">{localize(/* @kp-localization user.MvsLibrary */ 'user.MvsLibrary')}</span>
            {/if}
            {#if value.role?.includes('ROLE_SUPPLIER')}
                <span class="label label-info">{localize(/* @kp-localization user.Supplier */ 'user.Supplier')}</span>
            {/if}
        </div>
        <div class="detail">
            {#each value.userRoles ?? [] as role}
            <span>
                {#if role.cardNumber}
                    <span class="text-muted">{localize(/* @kp-localization ctenar.cardNumber */ 'ctenar.cardNumber')} </span>{pipe(role.cardNumber, loc())},
                {/if}
                {#if role.barCode}
                    <span class="text-muted">{localize(/* @kp-localization ctenar.barCode */ 'ctenar.barCode')} </span>{pipe(role.barCode, loc())},
                {/if}
                {#if role.readerCategory}
                    <span class="text-muted">{localize(/* @kp-localization commons.kategorie */ 'commons.kategorie')} </span>{pipe(role.readerCategory, loc())},
                {/if}
                {#if role.editLevel > -1}
                    <span class="text-muted">{localize(/* @kp-localization user.LibrarianEditLevel */ 'user.LibrarianEditLevel')} </span>{role.editLevel},
                {/if}
                {#if role.group}
                    <span class="text-muted">{localize(/* @kp-localization user.UserGroup */ 'user.UserGroup')} </span>{pipe(role.group, loc())},
                {/if}
                {#if role.validationCode}
                    <span class="text-muted">{localize(/* @kp-localization user.ValidationCode */ 'user.ValidationCode')} </span>{role.validationCode},
                {/if}
                {#if role.withServicePrivileges}
                    <span>se servisními právy,</span>
                {/if}
            </span>
            {/each}
            <div>
                {#if value.readableDepartments && Array.isArray(value.readableDepartments) && value.readableDepartments.length > 0}
                    <span class="text-muted">{localize(/* @kp-localization user.ReadableDepartments */ 'user.ReadableDepartments')} </span>{pipe(value.readableDepartments, prop('text'), inline(', '), characters(100))}
                {/if}
            </div>
        </div>
    </div>
</template>